export const validationRules = {
  firstName: {
    empty: true, // cannot be empty
    //maxLength: 64,
    //pattern: /^[a-zA-Z0-9]*$/, // only alpha numeric values allowed,
  },
  lastName: {
    empty: true, // cannot be empty
    //maxLength: 64,
    //pattern: /^[a-zA-Z0-9]*$/, // only alphanumeric  values allowed
  },
  address: {
    empty: true, // cannot be empty
    //maxLength: 64,
    //pattern: /^[a-zA-Z0-9]*$/, // only alphanumeric  value allowed
  },
  email2: {
    //pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // regular expression for a valid email address
  },
  /*   password: {
    minLength: 8, // Wachtwoord moet minimaal 8 tekens lang zijn
    pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/, // Moet minstens één cijfer, kleine letter en hoofdletter bevatten
  }, */
};

// input: translation object t
// output: object
export const getValidationMessages = (t) => {
  return {
    firstName: {
      empty: t("account.errors.emptyFirstName") ?? "Firstname is required.",
      maxLength: "Firstanme cannot exceed 64 characters.",
      pattern: "Firstname can only contain alphanumeric characters.",
      tab: "profile",
    },
    lastName: {
      empty: t("account.errors.emptyLastName") ?? "Firstname is required.",
      maxLength: "Firstanme cannot exceed 64 characters.",
      pattern: "Firstname can only contain alphanumeric characters.",
      tab: "profile",
    },
    address: {
      empty: t("account.errors.emptyAddress") ?? "Firstname is required.",
      maxLength: "Firstanme cannot exceed 64 characters.",
      pattern: "Firstname can only contain alphanumeric characters.",
      tab: "profile",
    },
    email2: {
      //pattern: "Please enter a valid email address.",
      tab: "profile",
    },
  };
};
